import { CommonState, Fetcher } from '@primeit/components-vue';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const module = {
  actions: {
    FETCH_ONE: async (context, params) => {
      let json = null;
      try {
        const response = await Fetcher(
          `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PROFESSIONAL}/specialties/${params.specId}`
        );

        if (response.ok) json = await response.json();
      } catch {
        json = {
          code: 500,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }
      context.commit('POPULATE_ONE', json);
    },
    FETCH_ALL: async (context, params) => {
      let json = [];
      try {
        const base = `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PROFESSIONAL}/specialties`;
        const name = params?.name && String(params.name).trim();
        const qs = [
          typeof params?.status === 'boolean' ? `status=${params.status}` : null,
          typeof params?.schedule === 'boolean' ? `schedule=${params.schedule}` : null,
          name ? `name=${encodeURIComponent(name)}` : null,
          params?.fields ? `fields=${params.fields}` : null,
        ]
          .filter(Boolean)
          .join('&');
        const response = await Fetcher(qs ? `${base}?${qs}` : base);
        if (response.ok) json = await response.json();
      } catch {
        json = {
          code: 500,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }
      context.commit('POPULATE_ALL', json);
    },
    FETCH_SAVE: async (context, params) => {
      let json;
      try {
        const response = await Fetcher(
          `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PROFESSIONAL}/specialties`,
          {
            body: JSON.stringify(params.entityToSave),
            headers,
            method: 'POST',
          }
        );
        if (response.ok) json = await response.json();
      } catch {
        json = {
          code: 500,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }
      context.commit('common/POPULATE_FEEDBACK', json, {
        root: true,
      });
    },
    FETCH_UPDATE: async (context, params) => {
      let json;
      try {
        const response = await Fetcher(
          `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PROFESSIONAL}/specialties/${params.specId}`,
          {
            body: JSON.stringify(params.entityToUpdate),
            headers,
            method: 'PUT',
          }
        );
        if (response.ok) json = await response.json();
      } catch {
        json = {
          code: 500,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }
      context.commit('common/POPULATE_FEEDBACK', json, {
        root: true,
      });
    },
    FETCH_INACTIVATE: async (context, params) => {
      let json;
      try {
        const response = await Fetcher(
          `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PROFESSIONAL}/specialties/${params.specId}`,
          {
            headers,
            method: 'DELETE',
          }
        );
        if (response.ok) json = await response.json();
      } catch {
        json = {
          code: 500,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }
      context.commit('common/POPULATE_FEEDBACK', json, {
        root: true,
      });
    },
  },
  getters: {
    GET_ALL: (state) => {
      return JSON.parse(JSON.stringify(state.entities));
    },
    GET_ONE: (state) => {
      return state.entity ? JSON.parse(JSON.stringify(state.entity)) : null;
    },
  },
  mutations: {
    POPULATE_ALL: (state, payload) => {
      if (payload) {
        state.entities = payload;
      }
    },
    POPULATE_ONE: (state, payload) => {
      state.entity = payload;
    },
  },
  namespaced: true,
  state: {
    entities: [],
    entity: null,
  },
};
CommonState.registerModule('specialty', module);
